<p class="text-Gray-800 text-base">
  Select the credit union you want to work in. Opportunities, participations and reports will show data for the credit
  union you choose.
</p>

<div class="mt-5">
  @if (isLoading()) {
    <div class="flex justify-center py-6">
      <p-progressspinner strokeWidth="4" styleClass="w-10 h-10" />
    </div>
  } @else if (useRadioList()) {
    <div class="flex flex-col gap-4">
      @for (creditUnion of creditUnions(); track creditUnion.id) {
        <label class="flex items-start gap-3 cursor-pointer" [for]="'credit-union-' + creditUnion.id">
          <p-radiobutton name="creditUnion" [inputId]="'credit-union-' + creditUnion.id" [value]="creditUnion.id"
            [ngModel]="selectedCreditUnionId()" (ngModelChange)="selectedCreditUnionId.set($event)" />
          <span class="flex flex-col">
            <span class="font-bold text-Gray-1000">{{ creditUnion.creditUnionName }}</span>
            <span class="text-sm text-Gray-800">Charter {{ creditUnion.charterNumber }} · {{ roleLabel(creditUnion.role) }}</span>
          </span>
        </label>
      }
    </div>
  } @else {
    <p-select [options]="creditUnions()" optionLabel="creditUnionName" optionValue="id" placeholder="Select a Credit Union"
      [ngModel]="selectedCreditUnionId()" (ngModelChange)="selectedCreditUnionId.set($event)" [filter]="true"
      filterBy="creditUnionName,charterNumber" styleClass="w-full" appendTo="body" [virtualScroll]="true"
      [virtualScrollItemSize]="56" scrollHeight="280px">
      <ng-template let-creditUnion #item>
        <div class="flex flex-col">
          <span class="font-bold text-Gray-1000">{{ creditUnion.creditUnionName }}</span>
          <span class="text-sm text-Gray-800">Charter {{ creditUnion.charterNumber }} · {{ roleLabel(creditUnion.role) }}</span>
        </div>
      </ng-template>
    </p-select>
  }
</div>

<div class="flex justify-center gap-2 mt-8 max-[576px]:mt-auto max-[576px]:pt-8">
  <button class="secondary-btn" (click)="cancel()">Cancel</button>
  <button class="main-btn max-[576px]:flex-1" (click)="apply()" [disabled]="!canApply()">Apply</button>
</div>
